<template>
  <div
    class="BaseTemplateLayerItem q-px-sm q-py-xs flex items-center gap-sm cursor-pointer transition rounded-8"
    :class="[
      !isActiveOrHover ? (item.is_show ? 'text-cool-gray-80' : 'text-cool-gray-60') : 'text-cool-gray-100',
      { 'bg-teal-white-20 ': isActiveOrHover },
    ]"
    :draggable="isActiveOrHover"
    @mouseenter="isHover = true"
    @mouseleave="isHover = false"
    @dragover="$emit('item-dragover', item)"
    @dragstart="isActiveOrHover && $emit('item-dragstart', item)"
    @dragend="isActiveOrHover && $emit('item-dragend')"
  >
    <k-icon
      :name="!isActiveOrHover ? 'link-2' : 'arrangement'"
      size="24px"
      :class="{ invisible: !item.is_field && !isActiveOrHover }"
      :color="!isActiveOrHover ? (item.is_show ? 'info-70' : 'cool-gray-50') : 'cool-gray-60'"
    />
    <k-icon :name="typeToIcon[item.type]" size="24px" :color="item.is_show ? 'cool-gray-70' : 'cool-gray-50'" />
    <p class="flex-1 BaseTemplateLayerItem__title q-mb-none fs-13px fw-500">
      <span v-if="item.type === 'text'" class="text-capitalize">{{ typeof item.value === 'string' ? item.value : item.value.title }}</span>
      <span v-else>{{ t(`contents.${item.type}`) }} </span>
    </p>

    <k-icon v-if="isActiveOrHover" name="trash" color="error-70" size="24px" @click="$emit('delete')" />
    <k-icon
      :name="item.is_show ? 'eye' : 'close-eye'"
      size="24px"
      :color="item.is_show ? 'cool-gray-70' : 'cool-gray-50'"
      @click.stop="$emit('toggle-show')"
    />
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import translate from 'src/common/helpers/language/translate'
import translationObject from '../../translate/baseTemplate.translate'

defineOptions({ name: 'BaseTemplateLayerItem' })
defineEmits(['toggle-show', 'item-dragover', 'item-dragstart', 'item-dragend', 'delete'])
const props = defineProps({
  item: { type: Object, required: true },
  isActive: { type: Boolean, default: false },
})

const typeToIcon = {
  text: 'text',
  shape: 'shapes',
  image: 'add-image',
}

const { t } = translate(translationObject)

const isHover = ref(false)

const isActiveOrHover = computed(() => isHover.value || props.isActive)
</script>

<style lang="sass" scoped>
.BaseTemplateLayerItem__title
  width: 224px
  text-overflow: ellipsis
  overflow: hidden
  white-space: nowrap
  line-height: 24px !important
</style>
